import api from './api';

const logsService = {
  trackPageVisit: async ({ path, fullUrl, pageTitle }) => {
    const response = await api.post('/logs/track', {
      path,
      fullUrl,
      pageTitle
    });
    return response.data;
  },

  getHRActivityLogs: async (params = {}) => {
    const query = new URLSearchParams();

    if (params.fromDate) query.append('fromDate', params.fromDate);
    if (params.toDate) query.append('toDate', params.toDate);
    if (params.role) query.append('role', params.role);
    if (params.userId) query.append('userId', String(params.userId));
    if (params.search) query.append('search', params.search);
    if (params.page) query.append('page', String(params.page));
    if (params.limit) query.append('limit', String(params.limit));

    const response = await api.get(`/logs/hr-activity?${query.toString()}`);
    return response.data;
  },

  getHRUsers: async (params = {}) => {
    const query = new URLSearchParams();

    if (params.role) query.append('role', params.role);

    const response = await api.get(`/logs/hr-users?${query.toString()}`);
    return response.data;
  }
};

export default logsService;
